import { t as e } from "../../constants-B7fXbm2f.js";
import { t } from "../../_plugin-vue_export-helper-B52Kst-M.js";
import { createElementBlock as n, createElementVNode as r, normalizeClass as i, openBlock as a } from "vue";
//#region ../src/icons/wind.vue
var o = {
	name: "DtIconWind",
	props: {
		size: {
			type: String,
			default: "500",
			validator: (t) => Object.keys(e).includes(t)
		},
		ariaLabel: {
			type: String,
			default: void 0
		}
	},
	emits: ["loaded"],
	computed: {
		iconSizeClass() {
			return e[this.size];
		},
		ariaHidden() {
			return this.ariaLabel ? "false" : "true";
		},
		dataQA() {
			return this.$attrs["data-qa"] ?? "dt-icon";
		}
	},
	created() {
		this.$emit("loaded");
	}
}, s = [
	"aria-label",
	"data-qa",
	"aria-hidden"
];
function c(e, t, o, c, l, u) {
	return a(), n("svg", {
		"aria-label": o.ariaLabel,
		class: i([u.iconSizeClass, "d-icon d-icon--wind"]),
		"data-qa": u.dataQA,
		"aria-hidden": u.ariaHidden,
		role: "img",
		"data-name": "Wind",
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 12 12"
	}, [...t[0] || (t[0] = [r("path", {
		fill: "currentColor",
		"fill-rule": "evenodd",
		d: "M9.869 4.016a.75.75 0 0 0-.672.194.5.5 0 0 1-.694-.72 1.75 1.75 0 1 1 1.26 3.01H1a.5.5 0 1 1 0-1h8.743a.75.75 0 0 0 .126-1.484Z",
		"clip-rule": "evenodd"
	}, null, -1), r("path", {
		fill: "currentColor",
		"fill-rule": "evenodd",
		d: "M5.61 2.51a.5.5 0 0 0-.453.14.5.5 0 1 1-.714-.7A1.5 1.5 0 1 1 5.497 4.5H1a.5.5 0 1 1 0-1h4.507a.5.5 0 0 0 .103-.99ZM6.997 7.5a1.5 1.5 0 1 1-1.054 2.55.5.5 0 1 1 .714-.7.5.5 0 1 0 .35-.85H1a.5.5 0 0 1 0-1h5.997Z",
		"clip-rule": "evenodd"
	}, null, -1)])], 10, s);
}
var l = /* @__PURE__ */ t(o, [["render", c]]);
//#endregion
export { l as default };

//# sourceMappingURL=wind.js.map